<template>
  <div class="comp-container" :class="{ 'comp-container__h5': isH5 }">
    <div class="back" @click="goBack">
      <img :src="arrowLeftImg" alt="" />返回
    </div>
    <div class="password-content">
      <div class="title">
        <h3>设置密码</h3>
        <p>
          为了提升账号安全，同时防止因无法获取验证码导致无法登录，请设置登录密码。密码仅可由数字、英文字母或特殊符号组成，且需包含其中至少2种类型，长度不少于8个字符。
        </p>
      </div>
      <div class="code-container">
        <el-form
          ref="passwordForm"
          :model="passwordForm"
          :rules="rules"
          label-width="0"
          @submit.native.prevent
        >
          <el-form-item prop="newPassword">
            <el-input
              v-model="passwordForm.newPassword"
              type="password"
              auto-complete="off"
              placeholder="请输入新密码，至少8位，包含数字、字母或特殊字符"
              @input="calculatePasswordStrength"
            />
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input
              v-model="passwordForm.confirmPassword"
              type="password"
              auto-complete="off"
              placeholder="请再次输入新密码以确认"
            />
          </el-form-item>
        </el-form>
        <div class="password-strength">
          <!-- 密码强度展示 -->
          <span>密码强度：</span>
          <el-progress
            :percentage="passwordStrengthPercentage"
            show-text
            :stroke-width="20"
            :text-inside="false"
            :color="strengthLevelColors[currentStrengthLevel]"
            :format="(percentage) => passwordStrengthText(percentage)"
          />
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button
        type="primary"
        class="next-step"
        :disabled="nextStepDisabled"
        @click="nextStep"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Login from "@saas/components/src/mixins/login";
import { isH5 } from "@saas/components/src";
const passwordRex =
  /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_]).{8,}$|^(?=.*\d)(?=.*[a-zA-Z]).{8,}$|^(?=.*\d)(?=.*[\W_]).{8,}$|^(?=.*[a-zA-Z])(?=.*[\W_]).{8,}$/;
export default {
  mixins: [Login],
  props: {
    // mobile: {
    //   type: String,
    //   default: ''
    // }
  },
  data() {
    return {
      arrowLeftImg: require("../../../assets/images/login/arrow-left.png"),
      passwordForm: {
        newPassword: "",
        confirmPassword: "",
      },
      passwordStrength: 0,
      passwordStrengthPercentage: 0,
      strengthLevels: ["弱", "中", "强"],
      strengthLevelColors: ["#FF919E", "#FFC391", "#00C89D"],
      currentStrengthLevel: 0,
      rules: {
        newPassword: [
          { required: true, message: "密码不能为空" },
          { validator: this.validatePassword, trigger: "change" },
          { validator: this.validatePassword, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空" },
          { validator: this.validateConfirmPassword, trigger: "change" },
          { validator: this.validatePassword, trigger: "blur" },
        ],
      },
      isH5: isH5(),
      //   returnUrl: null
    };
  },
  computed: {
    ...mapState("user", ["loginForm"]),
    nextStepDisabled() {
      return !(
        passwordRex.test(this.passwordForm.newPassword) &&
        this.passwordForm.newPassword === this.passwordForm.confirmPassword
      );
    },
  },
  mounted() {
    // this.returnUrl = this.$route.query.return_url || ''
  },
  methods: {
    // 注册
    nextStep() {
      this.$store
        .dispatch("user/register", {
          region_num: this.loginForm.region_num
            ? this.loginForm.region_num + ""
            : "",
          account: this.loginForm.mobile,
          password: this.passwordForm.newPassword,
          code: this.loginForm.code,
          scene_str: this.loginForm.sceneStr,
        })
        .then((res) => {
          if (res.code === 1) {
            this.loginSuccess();
            this.$message.success("注册成功");
          } else if (res.code === 20008) {
            // 已存在
            this.$message.error("用户已存在，请登录");
            this.$emit("accountExist");
          }
        });
    },
    validatePassword(rule, value, callback) {
      if (!passwordRex.test(this.passwordForm.newPassword)) {
        callback(
          new Error("密码必须至少8位，且包含数字、字母和至少一个特殊字符")
        );
      } else {
        callback();
      }
    },
    validateConfirmPassword(rule, value, callback) {
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    goBack() {
      this.$emit("back");
    },
    passwordStrengthText(percentage) {
      if (Math.floor(percentage / 33) === 0) {
        this.currentStrengthLevel = 0;
        return this.strengthLevels[0];
      } else {
        this.currentStrengthLevel = Math.floor(percentage / 33) - 1;
        return `${this.strengthLevels[Math.floor(percentage / 33) - 1]}`;
      }
    },
    // 计算密码强度
    calculatePasswordStrength() {
      const len = this.passwordForm.newPassword.length;
      const hasNumber = /\d/.test(this.passwordForm.newPassword);
      const hasLetter = /[a-zA-Z]/.test(this.passwordForm.newPassword);
      const hasSpecialChar = /[!@#$%^&*]/.test(this.passwordForm.newPassword);

      let strength = 0;

      // 根据密码长度、数字、字母和特殊字符的出现情况计算强度值
      if (len >= 8) strength += 1;
      if (hasNumber && hasLetter) strength += 1;
      if (hasSpecialChar) strength += 1;
      // 将强度值限制在4以内，并转换为百分比
      this.passwordStrength = Math.min(strength, 4);
      if (this.passwordStrength >= 3) {
        this.passwordStrengthPercentage = 100;
      } else {
        this.passwordStrengthPercentage = Math.ceil(this.passwordStrength * 33);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 480px;
  height: 550px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #dee0e3;
  -webkit-box-shadow: 0 4px 8px rgba(31, 35, 41, 0.03),
    0 3px 6px -6px rgba(31, 35, 41, 0.05), 0 6px 18px 6px rgba(31, 35, 41, 0.03);
  box-shadow: 0 4px 8px rgba(31, 35, 41, 0.03),
    0 3px 6px -6px rgba(31, 35, 41, 0.05), 0 6px 18px 6px rgba(31, 35, 41, 0.03);
  background-color: #fff;
  padding: 55px 48px 50px 48px;
  .back {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    color: #515350;
    line-height: 22px;
    img {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
  }

  .password-content {
    flex: 1;
    margin: 0;
    margin-top: 19px;
    .title {
      h3 {
        font-weight: 500;
        margin: 0;
        font-size: 24px;
        color: $saas-text-color;
        line-height: 33px;
      }
      p {
        margin-top: 8px;
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
    }
    .code-container ::v-deep {
      margin-top: 16px;
      .el-form-item {
        margin-bottom: 24px;
        &.is-error {
          .el-input__inner {
            border-color: #f03349;
          }
        }
      }
      .el-input__inner {
        height: 50px;
        border-radius: 16px;
        padding-left: 24px;
        font-size: 14px;
        &:focus {
          border-color: #00c89d;
        }
      }
      .el-form-item__error {
        padding-top: 6px;
        font-weight: 400;
        font-size: 12px;
        color: #f03349;
      }
      .password-strength {
        display: flex;
        height: 20px;
        align-items: center;
        span {
          font-size: 14px;
          color: #515350;
        }
        .el-progress {
          flex: 1;
          .el-progress-bar {
            height: 12px;
            .el-progress-bar__outer {
              height: 12px !important;
            }
          }
          .el-progress__text {
            font-size: 14px !important;
            color: #515350 !important;
          }
        }
      }
    }
  }

  .footer {
    width: 100%;
    .next-step {
      width: 100%;
      height: 50px;
      border-radius: 16px !important;
      border: none;
      font-weight: 600;
      font-size: 16px;
      color: #fff;
      background: linear-gradient(
        132deg,
        rgba(0, 235, 129, 1) 0%,
        rgba(0, 200, 157, 1) 100%
      ) !important;
      &:hover {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
      }
      &:focus {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
      }
      &.is-disabled {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 0.5) 0%,
          rgba(0, 200, 157, 0.5) 100%
        ) !important;
        &:hover {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
        &:focus {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
      }
    }
  }
}
.comp-container__h5 {
  width: 100%;
  height: 100%;
  border-radius: 0;
  border: none;
  box-shadow: none;
  padding: 0 0.6667rem;
  .back {
    position: absolute;
    left: 0.5067rem;
    top: 0.2667rem;
    display: inline-block;
    font-size: 0.4267rem;
    line-height: 0.6rem;
    img {
      display: inline-block;
      width: 0.4267rem;
      height: 0.4267rem;
      margin-right: 0.16rem;
    }
  }

  .password-content {
    margin: 0;
    margin-top: 1.3067rem;
    .title {
      h3 {
        font-size: 0.5333rem;
        line-height: 0.7467rem;
      }
      p {
        margin-top: 0.2667rem;
        font-size: 0.3467rem;
        line-height: 0.4933rem;
      }
    }
    .code-container ::v-deep {
      margin-top: 0.6667rem;
      .el-form-item {
        margin-bottom: 0.6667rem;
      }
      .el-input__inner {
        height: 1.3333rem;
        border-radius: 0.32rem;
        padding-left: 0.4rem;
        font-size: 0.32rem;
      }
      .el-form-item__error {
        height: 0.4rem;
        line-height: 0.4rem;
        padding-top: 0.1333rem;
        font-size: 0.2933rem;
      }
      .password-strength {
        margin-top: 0.1333rem;
        height: 0.5333rem;
        span {
          font-size: 0.3733rem;
        }
        .el-progress {
          flex: 1;
          .el-progress-bar {
            height: 0.32rem;
            .el-progress-bar__outer {
              height: 0.32rem !important;
            }
          }
          .el-progress__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }

  .footer {
    margin-top: 0.8rem;
    width: 100%;
    .next-step {
      width: 100%;
      height: 1.3333rem;
      font-size: 0.4267rem;

      border-radius: 0.32rem !important;
      border: none;
    }
  }
}

@keyframes identifier {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
